<template>
    <div>
      <ul>
        <li v-if="element.types.length > 1">
          <v-select
              label="Typ"
              v-model="element.element_type"
              @change="elementTypeChange(element, $event)"
              :items="typesItems"
              dense
          >
            <v-icon slot="prepend" v-tooltip="'Typ'">directions_run</v-icon>
          </v-select>
        </li>
        <li v-if="element.hasWarmup">
          <v-text-field
              v-model="element.warmup"
              label="Rozgrzewka"
              :error="hasErrors('warmup')"
              :error-messages="getErrors('warmup')"
          >
            <i slot="prepend" v-tooltip="'Rozgrzewka'" class="fi flaticon-people-1"></i>
          </v-text-field>

        </li>
        <li v-if="element.hasDistance">
          <v-text-field
              v-model="element.distance"
              label="Dystans"
              :error="hasErrors('distance')"
              :error-messages="getErrors('distance')"
              @change="$emit('distance-recalculate')"
          >
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1"></i>
          </v-text-field>
        </li>
        <li v-if="element.hasDistanceString">
          <v-text-field
              v-model="element.distance_string"
              label="Dystans"
              :error="hasErrors('distance_string')"
              :error-messages="getErrors('distance_string')"
              @change="$emit('distance-recalculate')"
          >
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1"></i>
          </v-text-field>
        </li>
        <li v-if="element.hasAscent">
          <v-text-field
              v-model="element.ascent"
              label="Podbieg"
              :error="hasErrors('ascent')"
              :error-messages="getErrors('ascent')"
          >
            <v-icon slot="prepend" v-tooltip="'Podbieg'">trending_up</v-icon>
          </v-text-field>
        </li>
        <li v-if="element.hasPulse">
          <v-text-field
              v-model="element.pulse"
              label="Tętno"
              :error="hasErrors('pulse')"
              :error-messages="getErrors('pulse')"
          >
            <i slot="prepend" v-tooltip="'Tętno'" class="fi flaticon-pulse-line"></i>
          </v-text-field>
        </li>
        <li v-if="element.hasPace">
          <v-text-field
              v-model="element.pace"
              label="Tempo"
              :error="hasErrors('pace')"
              :error-messages="getErrors('pace')"
          >
            <i slot="prepend" v-tooltip="'Tempo'" class="fi flaticon-minutes"></i>
          </v-text-field>
        </li>
        <li v-if="element.hasStrength">
          <v-text-field
              v-model="element.strength"
              label="Siła biegowa"
              :error="hasErrors('strength')"
              :error-messages="getErrors('strength')"
          >
            <i slot="prepend" v-tooltip="'Siła biegowa'" class="text-icon">SB</i>
          </v-text-field>
        </li>
        <li v-if="element.hasRepeats">
          <v-text-field
              v-model="element.repeats"
              label="Rytmy"
              :error="hasErrors('repeats')"
              :error-messages="getErrors('repeats')"
          >
            <i slot="prepend" v-tooltip="'Rytmy'" class="text-icon">R</i>
          </v-text-field>
        </li>
        <li v-if="element.hasBreak">
          <v-text-field
              v-model="element.break_time"
              label="Przerwa"
              :error="hasErrors('break_time')"
              :error-messages="getErrors('break_time')"
          >
            <i slot="prepend" v-tooltip="'Przerwa'" class="fi flaticon-people"></i>
          </v-text-field>
        </li>
        <li v-if="element.hasDescent">
          <v-text-field
              v-model="element.descent"
              label="Zbieg"
              :error="hasErrors('descent')"
              :error-messages="getErrors('descent')"
          >
            <v-icon slot="prepend" v-tooltip="'Zbieg'">trending_down</v-icon>
          </v-text-field>
        </li>
        <li v-if="element.hasTrip">
          <v-text-field
              v-model="element.trip_place"
              label="Miejsce"
              :error="hasErrors('trip_place')"
              :error-messages="getErrors('trip_place')"
          >
            <v-icon slot="prepend" v-tooltip="'Miejsce'">place</v-icon>
          </v-text-field>
        </li>
        <li v-if="element.hasTrip">
          <v-text-field
              v-model="element.trip_link"
              label="Miejsce (link)"
              :error="hasErrors('trip_link')"
              :error-messages="getErrors('trip_link')"
          >
            <v-icon slot="prepend" v-tooltip="'Miejsce (link)'">insert_link</v-icon>
          </v-text-field>
        </li>
        <li v-if="element.hasCooling">
          <v-text-field
              v-model="element.cooling"
              label="Schłodzenie"
              :error="hasErrors('cooling')"
              :error-messages="getErrors('cooling')"
          >
          <i slot="prepend" v-tooltip="'Schłodzenie'" class="text-icon">C</i>
          </v-text-field>
        </li>
        <li v-if="element.hasOther">
          <v-text-field
              v-model="element.other"
              label="Inny trening"
              :error="hasErrors('other')"
              :error-messages="getErrors('other')"
          >
            <v-icon slot="prepend" v-tooltip="'Inny trening'">short_text</v-icon>
          </v-text-field>
        </li>
      </ul>
      <div v-if="element.multiple" class="element-actions">
        <v-icon class="click-effect" v-if="element.multiple" v-tooltip="'Dodaj'" @click.stop="addNewElement(element)">add_circle_outline</v-icon>
        <v-icon class="click-effect" v-if="element.next" v-tooltip="'Usuń'" @click.stop="removeElement(element)">remove_circle_outline</v-icon>
      </div>
    </div>
</template>
<script>

export default {
  props: {
    element: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    typesItems () {
      const ELEMENT_TYPES = {
        'OWB1': 'OWB1',
        'STD': 'Standardowy',
        'R': 'Rytmy',
        'SB': 'Siła biegowa',
        'R + SB': 'Rytmy i siła biegowa',
        'OWB1+R': 'OWB1 + R',
        'OWB1+SB': 'OWB1 + SB',
        'OWB1+R+SB': 'OWB1 + R + SB',
        'SPEED': 'Akcent',
        'ASCENT': 'Podbieg',
        'TRIP': 'Wycieczka',
        'LOCATION': 'Miejsce',
        'OTHER': 'Inne',
        'WARMUP': 'Rozgrzewka',
        'COOLING': 'Schłodzenie'
      }
      let elements = []
      for (let et of this.element.types) {
        elements.push({text: ELEMENT_TYPES[et] || et, value: et})
      }
      return elements
    }
  },
  methods: {
    elementTypeChange (el, value) {
      this.$emit('type-change-element', this.element, value)
    },
    addNewElement (el) {
      this.$emit('add-element', this.element)
    },
    removeElement (el) {
      this.$emit('remove-element', this.element)
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/WorkoutFormElement.vue